import reducer from "./reducer";
export { default as AssetsDiscountsSummary } from "./components/index";
export { default as assetsDiscountsSummaryReducerName } from "./constants";
export default reducer;
